import RequestStatus from "../model/RequestStatus";
import {CurrentCountryCodeResponse} from "src/model/ProductMatch";

export const CURRENT_COUNTRY_CODE_QUERY_START = 'CURRENT_COUNTRY_CODE_QUERY_START';
export const CURRENT_COUNTRY_CODE_QUERY_SUCCESS = 'CURRENT_COUNTRY_CODE_QUERY_SUCCESS';
export const CURRENT_COUNTRY_CODE_QUERY_FAILED = 'CURRENT_COUNTRY_CODE_QUERY_FAILED';
export const CURRENT_COUNTRY_CODE_SET = 'CURRENT_COUNTRY_CODE_SET';

export interface CurrentCountryCodeQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus
}

export const setCurrentCountryCodeQueryStart = (): CurrentCountryCodeQueryStartAction => ({
    type: CURRENT_COUNTRY_CODE_QUERY_START,
    requestStatus: RequestStatus.LOADING
});

export interface GetCurrentCountryCodeComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly currentCountryCode: any;
}

export const getCurrentCountryCodeQuerySuccessAction = (response: CurrentCountryCodeResponse): GetCurrentCountryCodeComplete => ({
    type: CURRENT_COUNTRY_CODE_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    currentCountryCode: response.currentCountryCode
});

export const getCurrentCountryCodeQueryFailedAction = (): GetCurrentCountryCodeComplete => ({
    type: CURRENT_COUNTRY_CODE_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    currentCountryCode: null
});

export const setCurrentCountryCodeAction = (countryCode: string) : GetCurrentCountryCodeComplete => ({
    type: CURRENT_COUNTRY_CODE_SET,
    requestStatus: RequestStatus.SUCCESS,
    currentCountryCode: countryCode
});